import React, { createContext, useState, useContext, useEffect } from 'react';
import authService from '../services/authService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Add loading state

  useEffect(() => {
    const userData = authService.getCurrentUser();
    // console.log("AuthProvider - retrieved user:", userData);
    if (userData) {
      setUser(userData);
      setIsAuthenticated(true);
    }
    setIsLoading(false); // Finished checking
  }, []);

  useEffect(() => {
    if (!isAuthenticated) return undefined;

    const refreshTimer = setInterval(() => {
      authService.refreshSession().catch(() => {
        authService.logout();
        setUser(null);
        setIsAuthenticated(false);
      });
    }, 10 * 60 * 1000);

    return () => clearInterval(refreshTimer);
  }, [isAuthenticated]);

  const login = async (credentials) => {
    const user = await authService.login(credentials);
    setUser(user);
    setIsAuthenticated(true);
  };

  const register = async (userData) => {
    const user = await authService.register(userData);
    setUser(user);
    setIsAuthenticated(true);
  };

  const logout = async () => {
    await authService.logout();
    setUser(null);
    setIsAuthenticated(false);
  };

  const googleLogin = async (idToken) => {
    const user = await authService.googleLogin(idToken);
    setUser(user);
    setIsAuthenticated(true);
  };

  const logoutAll = async () => {
    await authService.logoutAll();
    setUser(null);
    setIsAuthenticated(false);
  };

  const updateProfile = async (profileData) => {
    const updatedUser = await authService.updateProfile(profileData);
    setUser(updatedUser);
    return updatedUser;
  };

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, isLoading, login, register, googleLogin, logout, logoutAll, updateProfile }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
